import QUERY from '@/api_app/ServiceResponse'
import { Toast } from 'vant';

const getDefaultState = () => {
  return {
  }
}

const state = getDefaultState()

const mutations = {
  SET_DATA: (state, {key,data}) => {
    state[key] = data;
  },
}

const actions = {
    
  Diagnostic({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key:'Diagnostic' ,params}).then(response => {
        const { data } = response
        // if(data.code!=1000){
        //   Toast(data.message)
        // }else{
          commit('SET_DATA',{ key:'Diagnostic', data:data })
        // }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

